import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  role: string;
  tenantId: string;
  tenantName: string;
  twoFactorEnabled?: boolean;
  twoFactorMethod?: 'TOTP' | 'DUO' | null;
  notifyEmail?: boolean;
  notifyPush?: boolean;
  notifySms?: boolean;
  notifyWhatsapp?: boolean;
  adminRoleId?: string | null;
  adminPermissions?: string[];
  tenantPermissions?: string[];
  /** Mobile bottom-nav tab keys visible for this user's role (resolved server-side). */
  mobileNavTabs?: string[];
  /** Add-on modules activated for the user's tenant (ModuleKey[]) */
  enabledModules?: string[];
  cguAccepted?: boolean;
  mustSetup2FA?: boolean;
  /** Dispatcher UI language ('fr' | 'en' | 'de'). */
  language?: string;
}

interface AuthState {
  user: User | null;
  accessToken: string | null;
  isAuthenticated: boolean;
  setAuth: (user: User, accessToken: string) => void;
  setTokens: (accessToken: string) => void;
  setUser: (user: User) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      isAuthenticated: false,

      setAuth: (user, accessToken) =>
        set({
          user,
          accessToken,
          isAuthenticated: true,
        }),

      setTokens: (accessToken) =>
        set({
          accessToken,
        }),

      setUser: (user) =>
        set({
          user,
        }),

      logout: () =>
        set({
          user: null,
          accessToken: null,
          isAuthenticated: false,
        }),
    }),
    {
      name: 'trackfleet-auth',
      partialize: (state) => ({
        user: state.user,
        accessToken: state.accessToken,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
